import { useIntervalEffect } from "@react-hookz/web";
import { useFeatureFlag } from "providers/LaunchDarkly";
import React from "react";
import { halloweenLoaderOptions, loaderInterval, loaderNext, loaderOptions } from "./constants";

/** A rotating `[emoji, message]` pair; spooky ones while the Halloween easter eggs are on. */
export const useLoaderOption = () => {
  const halloween = useFeatureFlag("halloween-easter-eggs");
  const options = halloween ? halloweenLoaderOptions : loaderOptions;
  const [index, setIndex] = React.useState(() => loaderNext(options.length));
  useIntervalEffect(() => {
    setIndex(loaderNext(options.length));
  }, loaderInterval);
  // The modulo only matters on the render where the flag flips between lists of different lengths.
  return options[index % options.length];
};
